import { createActionGroup, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Set logged in user': props<{userId: string | null, scopes: string[]}>(),
  }
});
